import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import queryString from "query-string";
import * as appConstants from "../../../config/constants";
import * as authDrawerActions from "../../../actions/authDrawer";
import {
  setLocalItem,
  removeLocalItem,
  getLocalItem,
} from "../../../utils/localdb";

class Authorize extends Component {
  componentDidMount() {
    const parsedQs = queryString.parse(this.props.location.search);
    const parsedHash = queryString.parse(this.props.location.hash);

    // If there is an access token present (this happens when Eden iframes in a page) persist it
    if (parsedQs.access_token) {
      setLocalItem("adminToken", parsedQs.access_token);
    }

    // If there is an access token present in the hash (this happens during FB and LI oAuth) set login session
    if (parsedHash.access_token && parsedHash.state && getLocalItem("socialNonce") && parsedHash.state === getLocalItem("socialNonce").toString()) {
      this.props.authDrawerActions.setAuthToken(parsedHash.access_token);

      removeLocalItem("socialNonce");
    }

    if (window.frameElement && !parsedQs.access_token) {
      window.parent.postMessage({
        authToken: queryString.parse(window.location.hash).access_token,
      }, appConstants.FRONTEND_ROOT);
    }

    // If there is a next direction, go to it
    if (parsedQs.next) {
      window.location.href = parsedQs.next;
    }
  }

  render() {
    return (
      <h2>Loading...</h2>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authDrawer: state.authDrawer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authorize));



// WEBPACK FOOTER //
// ./src/components/Library/Authorize/Authorize.js